import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <section className="relative bg-forest text-cream pt-16 pb-20 md:pt-24 md:pb-32 overflow-hidden" data-id="element-65">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-66">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-gold blur-3xl" data-id="element-67"></div>
        <div className="absolute bottom-0 left-1/4 w-64 h-64 rounded-full bg-cream blur-3xl" data-id="element-68"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-69">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-70">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left" data-id="element-71">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-6 text-cream-light" data-id="element-72">
              ¿Tu doctor en USA te dijo que{' '}
              <span className="text-gold" data-id="element-73">"estás en el borde"</span> de la
              diabetes y que debes dejar las tortillas?
            </h1>

            <h2 className="text-xl md:text-2xl font-semibold mb-6 text-cream" data-id="element-74">
              Cómo revertir tu glucosa y recuperar tu energía en 30 días SIN
              dejar el arroz, los frijoles ni el sazón de casa.
            </h2>

            <p className="text-base md:text-lg mb-10 text-cream-dark leading-relaxed" data-id="element-75">
              El primer sistema de "Biohacking Latino" diseñado para hombres y
              mujeres que trabajan duro en Estados Unidos y no quieren elegir
              entre su salud y sus alimentos culturales.
            </p>

            <div className="flex justify-center lg:justify-start" data-id="element-76">
              <CtaButton data-id="element-77" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-78">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform lg:-rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-79">
              <img src="https://cdn.magicpatterns.com/uploads/gY9h1YT9DpGdvKgaQX23EG/cover_codigo_metabokico_latino.png" alt="Portada del libro El Código Metabólico Latino mostrando un medidor de glucosa y tacos" className="w-full h-auto object-cover" data-id="element-80" />
              {/* Subtle overlay to make it look more like a physical object/tablet */}
              <div className="absolute inset-0 bg-gradient-to-tr from-black/20 to-transparent pointer-events-none" data-id="element-81"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}